import React, { useEffect, useState } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';
import cs from 'classnames';
import { FLOW_PADDING_Y } from '../FlowContainer/FlowEntry';

const XScrollWrapper = ({ children, offsetW = 0, innerW = 0 }) => {
  const [outerW, setOuterW] = useState(0);
  const resizeWindow = useDebouncedCallback(() => {
    setOuterW(document.body.clientWidth - offsetW);
  }, 400);
  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
    return () => {
      window.removeEventListener('resize', resizeWindow);
    };
  }, []);
  return (
    <div
      className={cs(
        'h-full border-b-[1px] px-[20px] bg-white overflow-x-auto tiny-scrollbar overflow-y-hidden',
        `py-[${FLOW_PADDING_Y}px]`,
      )}
      style={{ width: `${outerW}px` }}
    >
      <div className="h-full" style={{ width: `${innerW}px` }}>
        {children}
      </div>
    </div>
  );
};

export default XScrollWrapper;
